import api from './api';

/**
 * testiApi.js — la libreria dei testi riutilizzabili: frasi da inserire
 * in un referto e protocolli da consegnare, una tabella sola con una
 * portata («mio» o «della struttura»). Chi vede cosa lo decide il server.
 */
export const testiAPI = {
    elenco: (params) => api.get('/testi', { params }),
    dettaglio: (id) => api.get(`/testi/${id}`),
    crea: (dati) => api.post('/testi', dati),
    aggiorna: (id, dati) => api.put(`/testi/${id}`, dati),
    promuovi: (id) => api.post(`/testi/${id}/promuovi`),
    cancella: (id) => api.delete(`/testi/${id}`),
};
